import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminWarehouseApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_WAREHOUSE);
  }

  updatePurchaseOrderAddress(warehouseId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${warehouseId}/purchase-order-address/`,
      data,
    );
  }
}

export default new AdminWarehouseApi();
